import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { MobilityEdit } from '@/module/Author/Mobility/MobilityEdit';
import { getMobilityOptions } from '@/module/Author/Mobility/model/MobilityQuery';

export const Route = createFileRoute('/_auth/author/_author/mobility/_mobility/$mobilityId/_layout/edit')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.edit' },
  },
});

function RouteComponent() {
  const { mobilityId } = Route.useParams();
  const { data: mobility } = useSuspenseQuery(getMobilityOptions(mobilityId));

  return <MobilityEdit mobility={mobility} />;
}
